var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_8789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0C46.569 0 60 13.431 60 30C60 46.569 46.569 60 30 60C13.431 60 0 46.569 0 30C0 13.431 13.431 0 30 0ZM27.21 16.743C26.6551 16.7446 26.1234 16.9657 25.7311 17.3581C25.3387 17.7504 25.1176 18.2821 25.116 18.837V35.58C25.116 36.738 26.052 37.674 27.21 37.674H43.953C44.2345 37.6847 44.5152 37.6384 44.7783 37.5381C45.0415 37.4377 45.2817 37.2853 45.4846 37.0899C45.6875 36.8946 45.8489 36.6603 45.9592 36.4011C46.0694 36.1419 46.1262 35.8632 46.1262 35.5815C46.1262 35.2998 46.0694 35.0211 45.9592 34.7619C45.8489 34.5027 45.6875 34.2684 45.4846 34.0731C45.2817 33.8777 45.0415 33.7253 44.7783 33.6249C44.5152 33.5246 44.2345 33.4783 43.953 33.489H29.301V18.837C29.2994 18.2826 29.0787 17.7514 28.687 17.3591C28.2953 16.9668 27.7644 16.7454 27.21 16.743Z",
    fill: "#1527A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_8789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.1364a421f07f29a96839c9ea7af9a081.svg";
export { ForwardRef as ReactComponent };